import { Badge } from '@wundo/ui';
import type { InsightRunDetail } from '@/lib/insights.ts';
import { RUN_STATUS_TONE } from './runStatus.ts';

/** The line above a run's tabs: its status, what it cost, how long it took, which model ran it. */
export function RunFacts({
  run,
  duration,
}: {
  run: InsightRunDetail;
  duration: string | null;
}) {
  return (
    <div className='flex flex-wrap items-center gap-4 text-sm'>
      <Badge tone={RUN_STATUS_TONE[run.status]}>{run.status}</Badge>
      <span className='text-ink-muted'>
        Cost:{' '}
        <span className='font-semibold text-ink'>
          ${run.cost_usd.toFixed(2)} of ${run.budget_usd.toFixed(2)}
        </span>
      </span>
      {duration !== null && (
        <span className='text-ink-muted'>
          Duration: <span className='font-semibold text-ink'>{duration}</span>
        </span>
      )}
      <span className='text-ink-muted'>
        Model:{' '}
        <span className='font-semibold text-ink'>
          {run.routine_model.replace('openai/', '')} · {run.routine_reasoning_effort}
        </span>
      </span>
    </div>
  );
}
